import styled, { css } from 'styled-components';

import { SpinnerIcon } from 'components/ui/icons';
import { ElementTestId } from 'enums/testing';
import { hexToRGBA, type NonTransientProp } from 'utils/styledUtils';

import { OVERLAY_LIGHT } from 'styles/blanket';
import { BODY_TEXT_SECONDARY, DIVIDER } from 'styles/color';
import { NEUTRAL_0, NEUTRAL_700, NEUTRAL_900, SPACE_300, Z_INDEX_3 } from 'styles/tokens';

interface LoaderContainerProps {
  $zIndex?: number;
}

const LoaderContainer = styled.div<LoaderContainerProps>`
  align-items: center;
  background: ${OVERLAY_LIGHT};
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  opacity: 1;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: ${({ $zIndex }) => $zIndex ?? Z_INDEX_3};
`;

export const CircleContainer = styled.div`
  align-items: center;
  background: ${NEUTRAL_0};
  border-radius: 50%;
  box-shadow: 0 0 ${SPACE_300} 0 ${hexToRGBA(NEUTRAL_900, '0.13')};
  display: flex;
  height: 80px;
  justify-content: center;
  padding: 25px;
  width: 80px;
`;

export const Spinner = styled(SpinnerIcon)`
  animation: rotate 2s linear infinite;
  fill: ${NEUTRAL_700};

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ListItemSpinner = styled(Spinner)`
  fill: ${BODY_TEXT_SECONDARY};
  height: 14px;
  width: 14px;
`;

const SpinnerLoader = () => (
  <CircleContainer data-testid={ElementTestId.SPINNING_LOADER}>
    <Spinner />
  </CircleContainer>
);

const Loader = ({ zIndex, ...props }: NonTransientProp<LoaderContainerProps>) => (
  <LoaderContainer $zIndex={zIndex} {...props}>
    <SpinnerLoader />
  </LoaderContainer>
);

export const PageLoader = ({ zIndex }: { zIndex?: number }) => (
  <Loader
    css={css`
      background: ${DIVIDER};
    `}
    zIndex={zIndex}
  />
);

export default Loader;
